(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["single-product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const form = document.querySelector('.buy-it-now-form');
    if (!form) return;

    const button = form.querySelector('.buy-it-now-btn');

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      
      const formData = new FormData(form);
      const url = form.action;

      fetch(url, {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const cartCount = doc.querySelector('.cart-count')?.textContent;
        
        if (doc.querySelector('.cart-error')) {
          console.log('Form errors:', doc.querySelector('.cart-error').textContent);
          button.disabled = false;
        } else {
          window.location.href = '/checkout';
        }
      })
      .catch(function(error) {
        console.log('There was an error adding the item to the cart', error);
        window.location.href = '/checkout';
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
